"use client"

import { ChevronLeft, ChevronRight } from "lucide-react"
import { FONT_HEADING, FONT_SANS } from "@/lib/constants"
import type { RdvFlow } from "../_hooks/useRdvFlow"
import { errorTextStyle, inputStyle, labelStyle } from "./fields"

export function Step2Verification({ flow }: { flow: RdvFlow }) {
  const {
    syndicName,
    changeSyndicName,
    syndicError,
    syndicRejected,
    syndicLoading,
    retrySyndic,
    backToStep1,
    goToStep3,
  } = flow

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <button
        onClick={backToStep1}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: "#0EA5E9",
          fontFamily: FONT_SANS,
          fontSize: 14,
          fontWeight: 600,
          padding: 0,
          marginBottom: 4,
        }}
      >
        <ChevronLeft size={16} /> Modifier mes informations
      </button>

      {syndicRejected ? (
        /* Bloc refus : accès non autorisé */
        <div
          style={{
            background: "#FFF7ED",
            border: "1px solid #FED7AA",
            borderRadius: 16,
            padding: 28,
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <div style={{ fontSize: 32 }}>🏢</div>
          <h2
            style={{
              fontFamily: FONT_HEADING,
              fontSize: 18,
              fontWeight: 700,
              color: "#92400E",
              margin: 0,
            }}
          >
            Service réservé aux résidents partenaires
          </h2>
          <p style={{ fontSize: 14, color: "#78350F", lineHeight: 1.6, margin: 0 }}>
            Notre service de prise de rendez-vous en ligne est exclusivement disponible pour les
            résidents des résidences gérées par nos propriétaires partenaires.
          </p>
          <p style={{ fontSize: 14, color: "#78350F", lineHeight: 1.6, margin: 0 }}>
            Vous pouvez nous contacter directement par téléphone pour toute demande.
          </p>
          <button
            onClick={retrySyndic}
            style={{
              background: "transparent",
              border: "1px solid #FCD34D",
              borderRadius: 8,
              padding: "10px 16px",
              fontFamily: FONT_SANS,
              fontSize: 13,
              fontWeight: 600,
              color: "#92400E",
              cursor: "pointer",
              width: "fit-content",
            }}
          >
            ← Réessayer avec un autre nom
          </button>
        </div>
      ) : (
        /* Formulaire syndic */
        <div
          style={{
            background: "var(--ljs-surface)",
            border: "1px solid var(--ljs-border)",
            borderRadius: 16,
            padding: 28,
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <h2
            style={{
              fontFamily: FONT_HEADING,
              fontSize: 20,
              fontWeight: 700,
              color: "var(--ljs-text)",
              margin: 0,
            }}
          >
            Vérification de votre dossier
          </h2>
          <p style={{ fontSize: 14, color: "var(--ljs-text-dim)", lineHeight: 1.6, margin: 0 }}>
            Notre service est réservé aux résidents de résidences sous contrat. Merci
            d&apos;indiquer le nom de votre syndic ou de votre résidence pour confirmer votre
            éligibilité.
          </p>

          <div>
            <label style={labelStyle}>Nom de votre propriétaire ou bailleur *</label>
            <input
              style={{
                ...inputStyle,
                borderColor: syndicError ? "#EF4444" : "var(--ljs-border)",
              }}
              value={syndicName}
              onChange={(e) => changeSyndicName(e.target.value)}
              placeholder="Ex: Foncia, Nexity, Résidence Belleville…"
              onKeyDown={(e) => {
                if (e.key === "Enter") goToStep3()
              }}
            />
            {syndicError && <p style={errorTextStyle}>{syndicError}</p>}
          </div>

          <button
            onClick={goToStep3}
            disabled={syndicLoading}
            style={{
              background: syndicLoading ? "#7DD3FA" : "#0EA5E9",
              color: "#fff",
              fontFamily: FONT_SANS,
              fontSize: 15,
              fontWeight: 700,
              padding: "13px 0",
              borderRadius: 10,
              border: "none",
              cursor: syndicLoading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {syndicLoading ? (
              <>
                <div
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    border: "2px solid rgba(255,255,255,0.4)",
                    borderTopColor: "#fff",
                    animation: "spin 0.7s linear infinite",
                  }}
                />
                Vérification…
              </>
            ) : (
              <>
                Choisir un créneau <ChevronRight size={18} />
              </>
            )}
          </button>
        </div>
      )}
    </div>
  )
}
